export default __webpack_public_path__ + "static/media/iot.6b64f629.jpg";